//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import contentLibrarySocialSearchFilterSectionTemplate from '@legacy-components/content/content-library-social-search-filter-section.html';

import _ from "js/underscore-mixins";

(function() {
  const content = angular.module('curalate');

  content.component('contentLibrarySocialSearchFilterSection', {
    bindings: {
      collectionId: '<',
    },
    require: {
      searchFilterSet: '^searchFilterSet',
    },
    template: contentLibrarySocialSearchFilterSectionTemplate,
    controller: [
      '$scope',
      'AutocompleteTypes',
      'ContentLibraryApiService',
      'ContentSearchTypes',
      'SearchFilterService',
      'SocialSearchBarService',
      'TrackingService',
      'CONTENT_LIBRARY_CONTENT_GROUPS',
      'SEARCH_FILTERS',
      'rx',
      function(
                $scope,
                AutocompleteTypes,
                ContentLibraryApiService,
                ContentSearchTypes,
                SearchFilterService,
                SocialSearchBarService,
                TrackingService,
                CONTENT_LIBRARY_CONTENT_GROUPS,
                SEARCH_FILTERS,
                rx,
            ) {
        const self = this;

        let currentHashtags = [];
        let currentUsers = [];

        const filters = {};

        const ngUnsubscribe = new rx.Subject();
        let suggestionPromise;

        this.trackingCategory = TrackingService.CATEGORY_LIBRARY;

        this.getContentSuggestionsAsync = function(query) {
          const params = {
                        // Overwritten by the object unpacking, if the field exists.
                        // This defaults to "All" on the backend, which is all touched media (tagged, rights requested, etc...)
            contentGroup: 'Nothing',
            ...filters,
            collectionId: self.collectionId,
            f_hashtags: currentHashtags.join(','),
            f_users: currentUsers.join(','),
          };

          if (suggestionPromise) {
            suggestionPromise.abort();
            suggestionPromise = null;
          }

          suggestionPromise = ContentLibraryApiService.getAutocompleteSuggestionsAsync(
                        AutocompleteTypes.INSTAGRAM_USERS_AND_HASHTAGS,
                        query,
                        params,
                    );
          suggestionPromise.finally(() => {
            suggestionPromise = null;
            TrackingService.recordEvent(self.trackingCategory, TrackingService.ACTION_COLLECTIONS_SEARCH_SOURCES, 'Sidebar');
          });

          return suggestionPromise;
        };

        const handleContentSourcesUpdate = function(setUpdate) {
          if (setUpdate && setUpdate.setObject) {
            _(filters).extend(angular.copy(setUpdate.setObject));
          }
        };

        const handleContentFiltersUpdate = function(setUpdate) {
          if (setUpdate && setUpdate.setObject) {
            const contentFilters = _(setUpdate.setObject).omit(['igHashtag', 'igUsername', 'socialFilterOperand']);

            _(filters).extend(contentFilters);

            currentHashtags = setUpdate.setObject.igHashtag || [];
            currentUsers = setUpdate.setObject.igUsername || [];
          }
        };

        this.extractFilterValue = function(filterObj) {
          return SocialSearchBarService.generatePrefixedString(filterObj);
        };

        const processSocialSetUpdate = function(setUpdate) {
          const socialFilters = setUpdate.setObject.socialFilters;
          const contentFilters = _(setUpdate.setObject).omit('socialFilters');

          return _(contentFilters).extend({
            igHashtag: _.chain(socialFilters).where({ type: 'hashtag' }).pluck('value').value(),
            igUsername: _.chain(socialFilters).where({ type: 'username' }).pluck('value').value(),
            socialFilterOperand: ContentSearchTypes.STATE.ANY,
          });
        };

        this.$onInit = function() {
          SearchFilterService.transformFilterSet(
                        SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_PROCESSED,
                        SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS,
                        processSocialSetUpdate,
                    );

                    // Initialize starting value for the current state of the world
          const filtersSet = SearchFilterService.getRegisteredSet(SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_PROCESSED);
          handleContentFiltersUpdate({
            setObject: filtersSet.params || {},
          });
          const sourcesSet = SearchFilterService.getRegisteredSet(SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS);
          handleContentSourcesUpdate({
            setObject: _(sourcesSet).safeGet('params') || {},
          });

          SearchFilterService.getObservableForFilterSet(
                        SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_PROCESSED,
                    ).takeUntil(ngUnsubscribe).subscribe(handleContentFiltersUpdate);

          SearchFilterService.getObservableForFilterSet(
                        SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
                    ).takeUntil(ngUnsubscribe).subscribe(handleContentSourcesUpdate);
        };

        self.$onDestroy = function() {
          ngUnsubscribe.next();
          ngUnsubscribe.complete();
        };
      },
    ],
  });
})();
